/* stylelint-disable selector-max-compound-selectors */
sew-ws-richtext {
    display: block;
    overflow-wrap: break-word;

    h1,
    .sew-ws-h1 {
        @include typo-ws-h1;

        margin: 0 0 40px;
    }

    h2,
    .sew-ws-h2 {
        @include typo-ws-h2;

        margin: 40px 0 16px;
    }

    h2:last-child {
        margin-bottom: 40px !important;
    }

    h3,
    .sew-ws-h3 {
        @include typo-ws-h3;

        margin: 40px 0 16px;
    }

    h4,
    .sew-ws-h4 {
        @include typo-ws-h4;

        margin: 40px 0 16px;
    }

    h2 + h4,
    .sew-ws-h2 + .sew-ws-h4 {
        margin-top: 24px;
    }

    h5,
    .sew-ws-h5 {
        @include typo-ws-paragraph-bold;

        margin: 12px 0 0;
    }

    p {
        @include typo-ws-paragraph;

        margin: 16px 0 0;
    }

    b {
        @include typo-ws-paragraph-bold;
    }

    em {
        all: unset;
        color: $color-grey-02-steel;
    }

    p,
    li,
    strong {
        > a {
            color: var(--link-color, $color-red);
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    ul,
    ol {
        @include typo-ws-bulletlist;

        margin-top: 8px;
        padding-left: 20px;
    }

    ul {
        list-style-type: square;

        sew-ws-link[type='default'] {
            margin-top: 12px;

            &[size='large'] {
                margin-top: 16px;
            }
        }
    }

    ul.sew-no-bullets,
    ul.sew-no-bullets ul {
        list-style-type: none;
    }

    ul[data-icon] {
        list-style-type: none;
        padding-left: 0;

        li {
            display: flex;
            column-gap: 6px;

            sew-icon {
                color: $color-red;
                flex-shrink: 0;
            }
        }
    }

    ul.sew-no-bullets {
        padding: 0;

        > li:first-child {
            sew-ws-link[type='default'] {
                margin-top: 0;
            }
        }
    }

    li > ul,
    li > ol {
        margin-top: 0;
    }

    p + sew-ws-linklist {
        margin-top: 32px;
    }

    sew-ws-link {
        a:hover {
            text-decoration: none;
        }
    }

    sew-picture {
        margin-top: 40px;
    }

    sew-ws-button {
        margin-top: 32px;

        + sew-ws-button {
            margin-left: 20px;
        }
    }

    .sew-text-split {
        column-count: 2;
        gap: var(--column-gap);
        hyphens: auto;
    }

    h4 + .sew-text-split > ul {
        margin: 0;
    }

    &[small] {
        p {
            @include typo-ws-paragraph-s;
        }
    }

    &[large] {
        p {
            @include typo-ws-paragraph-l;
        }
    }

    &.underlay {
        background-color: $color-grey-06-bright;
        padding: 32px 40px;
    }

    &.breakout {
        padding-left: var(--grid-margin);
        margin-left: calc(var(--grid-margin) * -1);
    }
}

sew-ws-richtext:not(.margin-top):not(.margin-top-mq2) {
    > *:first-child {
        margin-top: 0;

        > sew-headline {
            margin-top: 0;
        }
    }
}

sew-ws-richtext:not(.margin-bottom) {
    > *:last-child {
        margin-bottom: 0;
    }
}

@include mq-3-min {
    sew-ws-richtext.margin-top-mq2 {
        > *:first-child {
            margin-top: 0;
        }
    }
}

@include mq-2 {
    sew-ws-richtext {
        .sew-text-split {
            column-count: 1;
            gap: var(--column-gap);
        }

        &.breakout {
            padding-right: var(--grid-margin);
            margin-right: calc(var(--grid-margin) * -1);
        }
    }
}

sew-ws-richtext.sew-ws-dark {
    color: $color-white;

    p,
    li {
        > a {
            color: var(--link-color, $color-red-theme-dark);
        }
    }
}

@include mq-1 {
    sew-ws-richtext {
        sew-ws-button {
            + sew-ws-button {
                margin-left: 0;
            }
        }
    }
}
